import React from 'react'
import usePageTitle from '../../hooks/usePageTitle'

export default function PrivacyPolicy() {
  usePageTitle('Политика конфиденциальности – СобеседникИИ')
  return (
    <div className="w-full px-[24px] pt-[40px] md:pt-[60px] pb-[40px] md:pb-[140px]">
      <div className="max-w-[995px] w-full mx-auto flex flex-col gap-[40px]">
        <h1 className="font-semibold text-[20px] md:text-[32px] leading-[24px] md:leading-[40px] text-center font-legal">
          Политика обработки персональных данных
        </h1>

        <div className="legal">
          <section>
            <h2>1. Общие положения</h2>
            <p>
              1.1. Настоящая Политика в отношении обработки персональных данных
              (далее – «Политика») подготовлена в соответствии с п. 2 ч .1 ст.
              18.1 Федерального закона Российской Федерации «О персональных
              данных» №152-ФЗ от 27 июля 2006 года (далее – «Закон») и
              определяет позицию юридического лица ООО "НЕЙРОПРОДАКШН" (ИНН
              7627062256, ОГРН 1257600007224) и/или его аффилированных лиц,
              (далее – «Компания») в области обработки и защиты персональных
              данных (далее – «Данные»), соблюдения прав и свобод каждого
              человека и, в особенности, права на неприкосновенность частной
              жизни, личную и семейную тайну. 1.1.1. Данные, которые
              автоматически передаются Программе в процессе ее использования с
              помощью установленного на устройстве пользователя программного
              обеспечения, в том числе IP-адрес, информация из cookie,
              информация о браузере пользователя (или иной программе, с помощью
              которой осуществляется доступ к Программе), время доступа, адрес
              запрашиваемой страницы.
              <br />
              1.2. Настоящая Политика распространяется на все сайты, приложения
              и сервисы, администрируемые ООО "НЕЙРОПРОДАКШН", включая, но не
              ограничиваясь:
              <span>- https://sobesednikai.ru</span>
              <span>- https://api.sobesednikai.ru</span>
              1.3. Все указанные ресурсы работают на единой технической
              платформе и используют общие правила обработки персональных
              данных.
            </p>
          </section>

          <section>
            <h2>2. Область применения</h2>
            <p>
              2.1. Настоящая Политика распространяется на Данные, полученные как
              до, так и после ввода в действие настоящей Политики.
              <br />
              2.2. Понимая важность и ценность Данных, а также заботясь о
              соблюдении конституционных прав граждан Российской Федерации и
              граждан других государств, Компания обеспечивает надежную защиту
              Данных.
            </p>
          </section>

          <section>
            <h2>3. Определения</h2>
            <p>
              3.1. Под Данными понимается любая информация, относящаяся к прямо
              или косвенно определенному или определяемому физическому лицу
              (гражданину), т.е. к такой информации, в частности, относятся:
              фамилия, имя, отчество, адрес регистрации/отправки
              корреспонденции, электронная почта, дата или место рождения,
              профессия, образование, уровень дохода, семейное положение,
              имущественное положение, ИНН, СНИЛС; информация, получаемая
              автоматически при использовании сайта, включая файлы cookie,
              IP-адрес, данные браузера, тип устройства, дату и время доступа;
              данные, собираемые с помощью сервисов аналитики, о действиях
              пользователя на сайте и в приложениях, просмотренных страницах,
              длительности сессий и переходах между страницами.
              <br />
              3.2. Под обработкой Данных понимается любое действие (операция)
              или совокупность действий (операций) с Данными, совершаемых с
              использованием средств автоматизации и/или без использования таких
              средств. К таким действиям (операциям) относятся: сбор, запись,
              систематизация, накопление, хранение, уточнение (обновление,
              изменение), извлечение, использование, передача (распространение,
              предоставление, доступ), обезличивание, блокирование, удаление,
              уничтожение Данных.
              <br />
              3.3. Под безопасностью Данных понимается защищенность Данных от
              неправомерного и/или несанкционированного доступа к ним,
              уничтожения, изменения, блокирования, копирования, предоставления,
              распространения Данных, а также от иных неправомерных действий в
              отношении Данных.
            </p>
          </section>

          <section>
            <h2>4. Правовые основания и цели обработки Данных</h2>
            <p>
              4.1. Обработка и обеспечение безопасности Данных в Компании
              осуществляется в соответствии с требованиями Конституции
              Российской Федерации, Закона, Трудового кодекса Российской
              Федерации, подзаконных актов, других определяющих случаи и
              особенности обработки Данных федеральных законов Российской
              Федерации, руководящих и методических документов ФСТЭК России и
              ФСБ России.
              <br />
              4.2. Субъектами Данных, обрабатываемых Компанией, являются:
              <span>
                1. Работники Компании, родственники работников Компании, в
                пределах определяемых законодательством Российской Федерации,
                если сведения о них предоставляются работником;
              </span>
              <span>
                2. Физические лица и юридические лица (далее Пользователи),
                пользующиеся сервисами, информацией, услугами, программами (в
                т.ч. программами лояльности) и продуктами сайта sobesednikai.ru
                (далее – Сайт), api.sobesednikai.ru (далее – Cервис передачи
                запросов), в том числе с целью оформления заказа с последующей
                доставкой пользователю;
              </span>
              <br />
              4.3. Компания осуществляет обработку Данных субъектов в следующих
              целях:
              <span>
                1. Осуществления возложенных на Компанию законодательством
                Российской Федерации функций, полномочий и обязанностей в
                соответствии с федеральными законами, в том числе, но не
                ограничиваясь: Гражданским кодексом Российской Федерации,
                Налоговым кодексом Российской Федерации, Трудовым кодексом
                Российской Федерации, Семейным кодексом Российской Федерации,
                Федеральным законом от 01.04.1996 г. № 27-ФЗ «Об индивидуальном
                (персонифицированном) учете в системе обязательного пенсионного
                страхования», Федеральным законом от 27.07.2006 г. № 152-ФЗ «О
                персональных данных», Федеральным законом от 28.03.1998 г. №
                53-ФЗ «О воинской обязанности и военной службе», Федеральным
                законом от 26.02.1997 г. № 31-ФЗ «О мобилизационной подготовке и
                мобилизации в Российской Федерации», Федеральным законом от
                8.02.1998 г. №14-ФЗ «Об обществах с ограниченной
                ответственностью», Федеральным законом от 07.02.1992 №2300-1 «О
                защите прав потребителей», Федеральным законом от 21.11.1996 г.
                № 129-ФЗ «О бухгалтерском учете», Федеральным законом от
                29.11.2010 г. № 326-ФЗ «Об обязательном медицинском страховании
                в Российской Федерации»
              </span>
              <span>
                2. Работников в целях соблюдения трудового, налогового и
                пенсионного законодательства Российской Федерации
              </span>
              <span>
                3. Клиентов – потребителей в целях:{' '}
                <span>
                  1. Предоставления информации по товарам/услугам, проходящим
                  акциям и специальным предложениям;
                </span>
                <span>
                  2. Анализа качества предоставляемого Компанией сервиса и
                  улучшению качества обслуживания клиентов Компании;
                </span>
                <span>
                  3. Анализа поведения пользователей и улучшения качества сайта
                  с помощью систем веб-аналитики;
                </span>
                <span>
                  4. Запоминания пользовательских настроек и предпочтений при
                  помощи cookie.
                </span>
              </span>
            </p>
          </section>

          <section>
            <h2>5. Использование файлов cookie и аналитики</h2>
            <p>
              5.1. Компания использует файлы cookie и аналогичные технологии для
              обеспечения корректной работы сайта, сохранения пользовательских
              настроек, персонализации контента, а также анализа
              пользовательской активности. Cookie — это небольшие фрагменты
              данных, которые сайт сохраняет на устройстве пользователя.
              Компания использует как собственные cookie, так и сторонние.
              <br />
              5.2. С помощью cookie Компания получает статистическую информацию:
              страницы, которые посещает посетитель-клиент, продолжительность
              визита, географию, устройство и технические параметры.
              <br />
              5.3. Данные, полученные с помощью cookie, могут передаваться на
              серверы, расположенные за пределами Российской Федерации, и
              использоваться для формирования обезличенной статистики.
              <br />
              5.4. Посетитель-клиент может изменить настройки использования
              cookie в своём браузере или воспользоваться функцией «Режим
              инкогнито».
              <br />
              5.5. При первом заходе на сайт посетитель-пользователь увидит
              уведомление с запросом согласия на использование cookie. Продолжая
              использовать сайт, посетитель-пользователь соглашается на их
              использование.
            </p>
          </section>

          <section>
            <h2>6. Принципы и условия обработки Данных</h2>
            <p>
              6.1. При обработке Данных Компания придерживается следующих
              принципов: обработка Данных осуществляется на законной и
              справедливой основе; Данные не раскрываются третьим лицам и не
              распространяются без согласия субъекта Данных, за исключением
              случаев, требующих раскрытия Данных по запросу уполномоченных
              государственных органов, судопроизводства; определение конкретных
              законных целей до начала обработки (в т.ч. сбора) Данных; ведется
              сбор только тех Данных, которые являются необходимыми и
              достаточными для заявленной цели обработки; объединение баз
              данных, содержащих Данные, обработка которых осуществляется в
              целях, несовместимых между собой не допускается; обработка Данных
              ограничивается достижением конкретных, заранее определенных и
              законных целей; обрабатываемые Данные подлежат уничтожению или
              обезличиванию по достижению целей обработки или в случае утраты
              необходимости в достижении этих целей, если иное не предусмотрено
              федеральным законом.
              <br />
              6.2. Компания может включать Данные субъектов в общедоступные
              источники Данных, при этом Компания берет письменное согласие
              субъекта на обработку его Данных, либо путем выражения согласия
              через форму сайта (чекбокс), нажатием которого субъект
              персональных данных выражает свое согласие.
              <br />
              6.3. Компания не осуществляет обработку Данных, касающихся
              расовой, национальной принадлежности, политических взглядов,
              религиозных, философских и иных убеждений, интимной жизни,
              членства в общественных объединениях, в том числе в
              профессиональных союзах.
              <br />
              6.4. Биометрические Данные (сведения, которые характеризуют
              физиологические и биологические особенности человека, на основании
              которых можно установить его личность и которые используются
              оператором для установления личности субъекта Данные) в Компании
              не обрабатываются.
              <br />
              6.5. Компания осуществляет трансграничную передачу Данных.
              <br />
              6.5.1. В рамках работы сайта Компания использует сервис Google
              Analytics, предоставляемый компанией Google LLC (США). В связи с
              этим персональные данные, включая cookie и техническую информацию,
              могут передаваться на сервера, расположенные за пределами
              Российской Федерации.
              <br />
              6.5.2. Такая передача осуществляется на основании согласия
              пользователя и при наличии соглашений, обеспечивающих
              соответствующий уровень защиты.
              <br />
              6.6. В случаях, установленных законодательством Российской
              Федерации, Компания вправе осуществлять передачу Данных третьим
              лицам (федеральной налоговой службе, государственному пенсионному
              фонду и иным государственным органам) в случаях, предусмотренных
              законодательством Российской Федерации.
              <br />
              6.7. Компания вправе поручить обработку Данных субъектов Данных
              третьим лицам с согласия субъекта Данных, на основании
              заключаемого с этими лицами договора, в том числе при согласии с
              пользовательским соглашением и политикой обработки персональных
              данных, размещенных на сайте.
              <br />
              6.8. Лица, осуществляющие обработку Данных на основании
              заключаемого с Компанией договора (поручения оператора), обязуются
              соблюдать принципы и правила обработки и защиты Данных,
              предусмотренные Законом. Для каждого третьего лица в договоре
              определяются перечень действий (операций) с Данными, которые будут
              совершаться третьим лицом, осуществляющим обработку Данных, цели
              обработки, устанавливается обязанность такого лица соблюдать
              конфиденциальность и обеспечивать безопасность Данных при их
              обработке, указываются требования к защите обрабатываемых Данных в
              соответствии с Законом.
              <br />
              6.9. В целях исполнения требований действующего законодательства
              Российской Федерации и своих договорных обязательств обработка
              Данных в Компании осуществляется как с использованием, так и без
              использования средств автоматизации. Совокупность операций
              обработки включает сбор, запись, систематизацию, накопление,
              хранение, уточнение (обновление, изменение), извлечение,
              использование, передачу (предоставление, доступ), обезличивание,
              блокирование, удаление, уничтожение Данных.
              <br />
              6.10. В Компании запрещается принятие на основании исключительно
              автоматизированной обработки Данных решений, порождающих
              юридические последствия в отношении субъекта Данных или иным
              образом затрагивающих его права и законные интересы, за
              исключением случаев, предусмотренных законодательством Российской
              Федерации.
              <br />
              6.11. В целях обеспечения безопасности Сервиса и предотвращения
              размещения запрещенного или опасного контента Компания может
              автоматически анализировать сообщения, отправляемые Пользователями
              в Сервисе. Такой анализ производится алгоритмическим способом и не
              используется для профилирования личности или принятия юридически
              значимых решений.
            </p>
          </section>

          <section>
            <h2>
              7. Права и обязанности субъектов Данных, а также Компании в части
              обработки Данных
            </h2>
            <p>
              7.1. Субъект, Данные которого обрабатываются Компанией, имеет
              право:
              <br />— получать от Компании:
              <span>
                1. Подтверждение факта обработки Данных и сведения о наличии
                Данных, относящихся к соответствующему субъекту Данных;
              </span>
              <span>
                2. Сведения о правовых основаниях и целях обработки Данных;
              </span>
              <span>
                3. Сведения о применяемых Компанией способах обработки Данных;
              </span>
              <span>
                4. Сведения о наименовании и местонахождении Компании;
              </span>
              <span>
                5. Сведения о лицах (за исключением работников Компании),
                которые имеют доступ к Данным или которым могут быть раскрыты
                Данные на основании договора с Компанией или на основании
                федерального закона;
              </span>
              <span>
                6. Перечень обрабатываемых Данных, относящихся к субъекту
                Данных, и информацию об источнике их получения, если иной
                порядок предоставления таких Данных не предусмотрен федеральным
                законом;
              </span>
              <span>
                7. Сведения о сроках обработки Данных, в том числе о сроках их
                хранения;
              </span>
              <span>
                8. Сведения о порядке осуществления субъектом Данных прав,
                предусмотренных Законом;
              </span>
              <span>
                9. Наименование (Ф.И.О.) и адрес лица, осуществляющего обработку
                Данных по поручению Компании;
              </span>
              <span>
                10. Иные сведения, предусмотренные Законом или другими
                нормативно-правовыми актами Российской Федерации;
              </span>
              — требовать от Компании:
              <span>
                1. Уточнения своих Данных, их блокирования или уничтожения в
                случае, если Данные являются неполными, устаревшими, неточными,
                незаконно полученными или не являются необходимыми для
                заявленной цели обработки;
              </span>
              <span>
                2. Отозвать свое согласие на обработку Данных в любой момент;
              </span>
              <span>
                3. Требовать устранения неправомерных действий Компании в
                отношении его Данных;
              </span>
              <span>
                4. Обжаловать действия или бездействие Компании в Федеральную
                службу по надзору в сфере связи, информационных технологий и
                массовых коммуникаций (Роскомнадзор) или в судебном порядке в
                случае, если субъект Данных считает, что Компания осуществляет
                обработку его Данных с нарушением требований Закона или иным
                образом нарушает его права и свободы;
              </span>
              — на защиту своих прав и законных интересов, в том числе на
              возмещения убытков и/или компенсацию морального вреда в судебном
              порядке. 7.2. Компания в процессе обработки Данных обязана:
              <span>
                1. Предоставлять субъекту Данных по его запросу информацию,
                касающуюся обработки его ПДн, либо на законных основаниях
                предоставить отказ в течение тридцати дней с даты получения
                запроса субъекта Данных или его представителя;
              </span>
              <span>
                2. Разъяснить субъекту Данных юридические последствия отказа
                предоставить Данные, если предоставление Данных является
                обязательным в соответствии с федеральным законом;
              </span>
              <span>
                3. До начала обработки Данных (если Данные получены не от
                субъекта Данных) предоставить субъекту Данных следующую
                информацию, за исключением случаев, предусмотренных частью 4
                статьи 18 Закона: 1) Наименование либо фамилия, имя, отчество и
                адрес Компании или ее представителя; 2) Цель обработки Данных и
                ее правовое основание; 3) Предполагаемые пользователи Данных; 4)
                Установленные Законом права субъектов Данных; 5) Источник
                получения Данных.
              </span>
              <span>
                4. Принимать необходимые правовые, организационные и технические
                меры или обеспечивать их принятие для защиты Данных от
                неправомерного или случайного доступа к ним, уничтожения,
                изменения, блокирования, копирования, предоставления,
                распространения Данных, а также от иных неправомерных действий в
                отношении Данных;
              </span>
              <span>
                5. Опубликовать в сети Интернет и обеспечить неограниченный
                доступ с использованием сети Интернет к документу, определяющему
                его политику в отношении обработки Данных, к сведениям о
                реализуемых требованиях к защите Данных;
              </span>
              <span>
                6. Предоставить субъектам Данных и/или их представителям
                безвозмездно возможность ознакомления с Данными при обращении с
                соответствующим запросом в течение 30 дней с даты получения
                подобного запроса;
              </span>
              <span>
                7. Осуществить блокирование неправомерно обрабатываемых Данных,
                относящихся к субъекту Данных, или обеспечить их блокирование
                (если обработка Данных осуществляется другим лицом, действующим
                по поручению Компании) с момента обращения или получения запроса
                на период проверки, в случае выявления неправомерной обработки
                Данных при обращении субъекта Данных или его представителя либо
                по запросу субъекту Данных или его представителя либо
                уполномоченного органа по защите прав субъектов персональных
                данных;
              </span>
              <span>
                8. Уточнить Данные либо обеспечить их уточнение (если обработка
                Данных осуществляется другим лицом, действующим по поручению
                Компании) в течение 7 рабочих дней со дня представления сведений
                и снять блокирование Данных, в случае подтверждения факта
                неточности Данных на основании сведений, представленных
                субъектом Данных или его представителем;
              </span>
              <span>
                9. Прекратить неправомерную обработку Данных или обеспечить
                прекращение неправомерной обработки Данных лицом, действующим по
                поручению Компании, в случае выявления неправомерной обработки
                Данных, осуществляемой Компанией или лицом, действующим на
                основании договора с Компанией, в срок, не превышающий 3 рабочих
                дней с даты этого выявления;
              </span>
              <span>
                10. Прекратить обработку Данных или обеспечить ее прекращение
                (если обработка Данных осуществляется другим лицом, действующим
                по договору с Компанией) и уничтожить Данные или обеспечить их
                уничтожение (если обработка Данных осуществляется другим лицом,
                действующим по договору с Компанией) по достижения цели
                обработки Данных, если иное не предусмотрено договором, стороной
                которого, выгодоприобретателем или поручителем по которому
                является субъект Данных, в случае достижения цели обработки
                Данных;
              </span>
              <span>
                11. Прекратить обработку Данных или обеспечить ее прекращение и
                уничтожить Данные или обеспечить их уничтожение в случае отзыва
                субъектом Данных согласия на обработку Данных, если Компания не
                вправе осуществлять обработку Данных без согласия субъекта
                Данных;
              </span>
              <span>
                12. Вести журнал учета обращений субъектов ПДн, в котором должны
                фиксироваться запросы субъектов Данных на получение Данных, а
                также факты предоставления Данных по этим запросам.
              </span>
            </p>
          </section>

          <section>
            <h2>8. Требования к защите Данных</h2>
            <p>
              8.1. Компания при обработке Данных принимает необходимые правовые,
              организационные и технические меры для защиты Данных от
              неправомерного и/или несанкционированного доступа к ним,
              уничтожения, изменения, блокирования, копирования, предоставления,
              распространения Данных, а также от иных неправомерных действий в
              отношении Данных.
              <br />
              8.2. К таким мерам в соответствии с Законом, в частности,
              относятся:
              <span>
                1. Назначение лица, ответственного за организацию обработки
                Данных, и лица, ответственного за обеспечение безопасности
                Данных;
              </span>
              <span>
                2. Разработка и утверждение локальных актов по вопросам
                обработки и защиты Данных;
              </span>
              <span>
                3. Применение правовых, организационных и технических мер по
                обеспечению безопасности Данных:
                <span>
                  — Определение угроз безопасности Данных при их обработке в
                  информационных системах персональных данных;
                </span>
                <span>
                  — Применение организационных и технических мер по обеспечению
                  безопасности Данных при их обработке в информационных системах
                  персональных данных, необходимых для выполнения требований к
                  защите Данных, исполнение которых обеспечивает установленные
                  Правительством Российской Федерации уровни защищенности
                  Данных;
                </span>
                <span>
                  — Применение прошедших в установленном порядке процедуру
                  оценки соответствия средств защиты информации;
                </span>
                <span>
                  — Оценка эффективности принимаемых мер по обеспечению
                  безопасности Данных до ввода в эксплуатацию информационной
                  системы персональных данных;
                </span>
                <span>
                  — Определение угроз безопасности Данных при их обработке в
                  информационных системах персональных данных;
                </span>
                <span>
                  — Учет машинных носителей Данных, если хранение Данных
                  осуществляется на машинных носителях;
                </span>
                <span>
                  — Обнаружение фактов несанкционированного доступа к Данным и
                  принятие мер по недопущению подобных инцидентов в дальнейшем;
                </span>
                <span>
                  — Восстановление Данных, модифицированных или уничтоженных
                  вследствие несанкционированного доступа к ним;
                </span>
                <span>
                  — Установление правил доступа к Данным, обрабатываемым в
                  информационной системе персональных данных, а также
                  обеспечение регистрации и учета всех действий, совершаемых с
                  Данными в информационной системе персональных данных.
                </span>
              </span>
              <span>
                4. Контроль за принимаемыми мерами по обеспечению безопасности
                Данных и уровнем защищенности информационных систем персональных
                данных;
              </span>
              <span>
                5. Оценка вреда, который может быть причинен субъектам Данных в
                случае нарушения требований Закона, соотношение указанного вреда
                и принимаемых Компанией мер, направленных на обеспечение
                выполнения обязанностей, предусмотренных Законом;
              </span>
              <span>
                6. Соблюдение условий, исключающих несанкционированный доступ к
                материальным носителям Данных и обеспечивающих сохранность
                Данных;
              </span>
              <span>
                7. Ознакомление работников Компании, непосредственно
                осуществляющих обработку Данных, с положениями законодательства
                Российской Федерации о Данных, в том числе с требованиями к
                защите Данных, локальными актами по вопросам обработки и защиты
                Данных, и обучение работников Компании.
              </span>
            </p>
          </section>

          <section>
            <h2>9. Сроки обработки (хранения) Данных</h2>
            <p>
              9.1. Сроки обработки (хранения) Данных определяются исходя из
              целей обработки Данных, в соответствии со сроком действия договора
              с субъектом Данных, требованиями федеральных законов, требованиями
              операторов Данных, по поручению которых Компания осуществляет
              обработку Данных, основными правилами работы архивов организаций,
              сроками исковой давности.
              <br />
              9.2. Данные, срок обработки (хранения) которых истек, должны быть
              уничтожены, если иное не предусмотрено федеральным законом.
              Хранение Данных после прекращения их обработки допускается только
              после их обезличивания.
            </p>
          </section>

          <section>
            <h2>
              10. Порядок получения разъяснений по вопросам обработки Данных
            </h2>
            <p>
              10.1. Лица, чьи Данные обрабатываются Компанией, могут получить
              разъяснения по вопросам обработки своих Данных, обратившись лично
              в Компанию или направив соответствующий письменный запрос по
              адресу местонахождения Компании: 150062, г. Ярославль, ул.
              Космонавтов, д. 11, пом. 1.
              <br />
              10.2. В случае направления официального запроса в Компанию в
              тексте запроса необходимо указать:
              <span>
                1. Фамилию, имя, отчество субъекта Данных или его представителя;
              </span>
              <span>
                2. Номер основного документа, удостоверяющего личность субъекта
                Данных или его представителя, сведения о дате выдачи указанного
                документа и выдавшем его органе;
              </span>
              <span>
                3. Сведения, подтверждающие наличие у субъекта Данных отношений
                с Компанией;
              </span>
              <span>
                4. Информацию для обратной связи с целью направления Компанией
                ответа на запрос;
              </span>
              <span>
                5. Подпись субъекта Данных (или его представителя). Если запрос
                отправляется в электронном виде, то он должен быть оформлен в
                виде электронного документа и подписан электронной подписью в
                соответствии с законодательством Российской Федерации.
              </span>
            </p>
          </section>

          <section>
            <h2>
              11. Особенности обработки и защиты Данных, собираемых Компанией с
              использованием сети Интернет
            </h2>
            <p>
              11.1. Компания обрабатывает Данные, поступающие от пользователей
              сайта sobesednikai.ru, сервиса передачи запросов
              api.sobesednikai.ru, а также поступающие на адрес электронной
              почты Компании: support@sobesednikai.ru. 10.2. Сбор Данных
              <br />
              11.2.1. Существуют два основных способа, с помощью которых
              Компания получает Данные с помощью сети Интернет:
              <span>
                1. Предоставление Данных (самостоятельный ввод данных):
                <br />— Фамилия
                <br />— Имя
                <br />— Адрес регистрации/отправки корреспонденции
                <br />— Электронная почта
                <br />— Дата или место рождения
                <br />— Профессия
                <br />— Образование
                <br />— Уровень дохода
                <br />— Семейное положение
                <br />— Имущественное положение
                <br />— ИНН
                <br />— СНИЛС
              </span>
              <span>
                2. Субъектами Данных путем поступления на адрес электронной
                почты Компании: support@sobesednikai.ru.
              </span>
              11.3. Автоматически собираемая информация
              <br />
              11.3.1. Компания может собирать и обрабатывать сведения, не
              являющимися персональными данными:
              <span>
                1. Информацию об интересах пользователей на сайтах на основе
                введенных поисковых запросов пользователей сайтов о реализуемых
                и предлагаемых к продаже товаров Компанией с целью
                предоставления актуальной информации клиентам Компании при
                использовании сайтов, а также обобщения и анализа информации, о
                том какие разделы сайтов и товары пользуются наибольшим спросом
                у клиентов Компании;
              </span>
              <span>
                2. Обработка и хранение поисковых запросов пользователей сайтов
                с целью обобщения и создания клиентской статистики об
                использовании разделов сайтов.
              </span>
              11.3.2. Компания автоматически получает некоторые виды информации,
              получаемой в процессе взаимодействия пользователей с Cайтом,
              переписки по электронной почте и т. п. Речь идет о технологиях и
              сервисах, таких как веб-протоколы, куки, веб-отметки, а также
              приложения и инструменты указанной третьей стороны.
              <br />
              11.3.3. При этом веб-отметки, куки и другие мониторинговые
              технологии не дают возможность автоматически получать Данные. Если
              пользователь сайта по своему усмотрению предоставляет свои Данные,
              например, при заполнении формы обратной связи или при отправке
              электронного письма, то только тогда запускаются процессы
              автоматического сбора подробной информации для удобства
              пользования сайтом и/или для совершенствования взаимодействия с
              пользователями.
              <br />
              11.4. Использование Данных
              <br />
              11.4.1. Компания вправе пользоваться предоставленными Данными в
              соответствии с заявленными целями их сбора при наличии согласия
              субъекта Данных, если такое согласие требуется в соответствии с
              требованиями законодательства Российской Федерации в области
              Данных.
              <br />
              11.4.2. Полученные Данные в обобщенном и обезличенном виде могут
              использоваться для лучшего понимания потребностей покупателей
              товаров и услуг, реализуемых Компанией и улучшения качества
              обслуживания.
              <br />
              11.5. Передача Данных
              <br />
              11.5.1. Компания может поручать обработку Данных третьим лицам
              исключительно с согласия субъекта Данных. Также Данные могут
              передаваться третьим лицам в следующих случаях:
              <span>
                1. B качестве ответа на правомерные запросы уполномоченных
                государственных органов, в соответствии с законами, решениями
                суда и пр.
              </span>
              <span>
                2. Данные не могут передаваться третьим лицам для маркетинговых,
                коммерческих и иных аналогичных целей, за исключением случаев
                получения предварительного согласия субъекта Данных.
              </span>
              11.6. Сайты содержат ссылки на иные веб-ресурсы, где может
              находиться полезная и интересная для пользователей сайтов
              информация. При этом действие настоящей Политики не
              распространяется на такие иные сайты. Пользователям, переходящим
              по ссылкам на другие сайты, рекомендуется ознакомиться с
              политиками об обработке Данных, размещенными на таких сайтах.
            </p>
          </section>

          <section>
            <h2>12. Заключительные положения</h2>
            <p>
              12.1. Настоящая Политика является локальным нормативным актом
              Компании. Настоящая Политика является общедоступной.
              Общедоступность настоящей Политики обеспечивается публикацией на
              сайтах Компании.
              <br />
              12.2. Настоящая Политика может быть пересмотрена в любом из
              следующих случаев:
              <span>
                1. При изменении законодательства Российской Федерации в области
                обработки и защиты персональных данных;
              </span>
              <span>
                2. В случаях получения предписаний от компетентных
                государственных органов на устранение несоответствий,
                затрагивающих область действия Политики;
              </span>
              <span>3. По решению руководства Компании;</span>
              <span>4. При изменении целей и сроков обработки Данных;</span>
              <span>
                5. При изменении организационной структуры, структуры
                информационных и/или телекоммуникационных систем (или введении
                новых);
              </span>
              <span>
                6. При применении новых технологий обработки и защиты Данных (в
                т. ч. передачи, хранения);
              </span>
              <span>
                7. При появлении необходимости в изменении процесса обработки
                Данных, связанной с деятельностью Компании.
              </span>
              12.3. В случае неисполнения положений настоящей Политики Компания
              и ее работники несут ответственность в соответствии с действующим
              законодательством Российской Федерации.
              <br />
              12.4. Контроль исполнения требований настоящей Политики
              осуществляется лицами, ответственными за организацию обработки
              Данных Компании, а также за безопасность персональных данных.
            </p>
          </section>

          <section>
            <h2>13. Контактная информация</h2>
            <p>
              Если у вас есть вопросы по настоящей Политике или вы хотите
              реализовать свои права, пожалуйста, свяжитесь с нами:
              <br />
              ООО "НЕЙРОПРОДАКШН"
              <br />
              E-mail: support@sobesednikai.ru
              <br />
              Сайт: sobesednikai.ru
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
